import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Container,
  Grid,
  CircularProgress,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from '@material-ui/core';

import { useSnackbar } from 'notistack';
import { useLocation, useHistory } from 'react-router-dom';
import styles from './styles';
import logoTCImg from '../../../../assets/images/logo_tc.png';
import schemaAuth from './Validators';

function NewPassword(props) {
  const { classes } = props;
  const { search } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [statusPassword, setStatusPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [statusConfirmPassword, setStatusConfirmPassword] = useState('');
  const token = new URLSearchParams(search).get('t');
  const history = useHistory();

  useEffect(() => {
    document.title = 'Extracto Bank | Nova senha';
  }, []);

  const handleValidationError = (err) => {
    err.inner.forEach((element) => {
      switch (element.path) {
        case 'password':
          setStatusPassword(element.message);
          break;
        default:
          break;
      }
    });
  };

  const hanldeNewPassword = () => {
    if (confirmPassword === '') {
      setStatusConfirmPassword('Por favor confirme sua senha.');
      return;
    }
    if (password !== confirmPassword) {
      setStatusConfirmPassword(
        'As senhas informadas não são iguais, por favor confirme sua senha novamente.',
      );

      return;
    }

    setLoading(true);
    schemaAuth
      .validate(
        {
          password,
        },
        { abortEarly: false },
      )
      .then(() => {
        // eslint-disable-next-line no-use-before-define
        submitNewPassword(password);
      })
      .catch((err) => {
        handleValidationError(err);
        setLoading(false);
        enqueueSnackbar(
          'Não foi possível alterar sua senha. Verifique os dados informados e tente novamente.',
          {
            variant: 'warning',
          },
        );
      });
  };

  async function submitNewPassword(newPassword) {
    await axios
      .patch('https://auth.trocacreditos.com.br/v1/redefine-password', {
        new_password: newPassword,
        token,
      })
      .then(() => {
        enqueueSnackbar('Senha redefinida com sucesso', {
          variant: 'success',
        });
        history.push('/login');
      })
      .catch((error) => {
        setLoading(false);
        enqueueSnackbar(error.message, {
          variant: 'warning',
        });
      });
  }

  return (
    <Container maxWidth="xs" className="lg-mg-top">
      <Grid container justify="center" alignItems="center" spacing={4}>
        <Grid item>
          <Grid container justify="center">
            <img src={logoTCImg} alt="logo" className={classes.imgLogo} />
          </Grid>
        </Grid>
        <Grid item>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              hanldeNewPassword();
            }}
          >
            <Grid item container xs={12} spacing={2}>
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={!!statusPassword}
                >
                  <InputLabel htmlFor="password">Nova senha</InputLabel>
                  <OutlinedInput
                    id="password"
                    autoComplete="off"
                    label="Nova senha"
                    value={password}
                    onChange={(e) => {
                      if (statusPassword) {
                        setStatusPassword('');
                      }
                      setPassword(e.target.value);
                    }}
                    type="password"
                  />
                  <FormHelperText>{statusPassword}</FormHelperText>
                </FormControl>

                <FormControl
                  fullWidth
                  variant="outlined"
                  error={!!statusConfirmPassword}
                  style={{ marginTop: 20 }}
                >
                  <InputLabel htmlFor="password">Confirmar senha</InputLabel>
                  <OutlinedInput
                    id="confirmPassword"
                    autoComplete="off"
                    label="Confirmar senha"
                    value={confirmPassword}
                    onChange={(e) => {
                      if (statusConfirmPassword) {
                        setStatusConfirmPassword('');
                      }
                      setConfirmPassword(e.target.value);
                    }}
                    type="password"
                  />
                  <FormHelperText>{statusConfirmPassword}</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  size="large"
                  endIcon={loading && <CircularProgress size={24} />}
                >
                  Alterar senha
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
}

NewPassword.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(NewPassword);
